<template>
  <div class="mt-2">
    <div class="mb-2">
      <v-btn
        icon
        :to="{
          name: 'diario-escolar-aulas',
          params: {
            ano,
            cdturma,
            disciplina,
            tipoDeEnsino,
            cdinstruc,
            pagina,
            filtro,
            AEEouACP,
          },
        }"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert
      type="error"
      :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0"
      dark
      class="mb-3"
    >
      <div v-if="$v.$invalid && $v.$dirty">
        Preencha os campos corretamente.
      </div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card>
      <v-toolbar color="blue" dark>
        <v-toolbar-title>{{
          id ? `Alterar Aula Número ${id}` : "Nova Aula"
        }}</v-toolbar-title>
      </v-toolbar>
      <div class="pa-4">
        <form @submit.prevent="onSubmit">
          <Select
            label="Período Avaliativo"
            v-model="form.cdpravadi"
            :v="$v.form.cdpravadi"
            :options="periodoAvaliativo"
          />
          <InputDate
            v-model="form.dataaula"
            label="Data da Aula"
            :v="$v.form.dataaula"
            max="10"
          />
          <Input
            class="mt-3"
            type="text"
            v-model="form.descricaoassuntolecionado"
            label="Assunto Lecionado"
            :v="$v.form.descricaoassuntolecionado"
          />
          <TextArea
            v-model="form.descricaodesenvolvimentoaula"
            label="Desenvolvimento da aula"
            :v="$v.form.descricaodesenvolvimentoaula"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaorecursosutilizados"
            label="Recursos utilizados"
            :v="$v.form.descricaorecursosutilizados"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaoatividadeassociada"
            label="Atividade Associada"
            :v="$v.form.descricaoatividadeassociada"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaoobjetivo"
            label="Objetivo"
            :v="$v.form.descricaoobjetivo"
          />
          <Validator label="Aula presencial?" :v="$v.form.indicapresencial">
            <Radio
              label="Sim"
              v-model="form.indicapresencial"
              val="S"
              :disabled="
                indicamodelodeaula === 'R' ||
                indicamodelodeaula === 'P' ||
                (this.id && indicamodelodeaula === 'H')
              "
            />
            <!-- Configuração do ano no modelo híbrido -->
            <Radio
              label="Não"
              v-model="form.indicapresencial"
              val="N"
              :disabled="
                indicamodelodeaula === 'R' ||
                indicamodelodeaula === 'P' ||
                (this.id && indicamodelodeaula === 'H')
              "
            />
          </Validator>
          <Validator label="Reposição?" :v="$v.form.indicareposicao">
            <Radio label="Sim" v-model="form.indicareposicao" val="S" />
            <Radio label="Não" v-model="form.indicareposicao" val="N" />
          </Validator>
          <InputDate
            v-model="form.datareposicao"
            :disabled="form.indicareposicao === 'N'"
            label="Referente a data"
            :v="$v.form.datareposicao"
          />
          <Validator label="Situação" :v="$v.form.indicasituacao">
            <Radio
              label="Elaboração"
              disabled
              v-model="form.indicasituacao"
              val="E"
            />
            <Radio
              label="Exibida para o público"
              disabled
              v-model="form.indicasituacao"
              val="P"
            />
          </Validator>
          <TextArea
            label="Observação"
            v-model="form.descricaoobservacao"
            :v="$v.form.descricaoobservacao"
          />
          <!-- <Input v-if="!(this.id)" type="number" label="Quantos módulos/aula?" v-model="form.qtdModulosAula" :v="$v.form.qtdModulosAula" :min="1" :max="quantidadeMaxAulasPermitidas" /> -->
          <Validator
            label="Campos de experiência"
            block
            v-if="false"
            style="flex: 100%; margin-top: 20px"
          >
            <div>
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia1"
                :label="'Eu, o outro e o nós'"
                :val="form.indicacampoexperiencia1 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia2"
                :label="'Corpo, gestos e movimentos'"
                :val="form.indicacampoexperiencia2 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia3"
                :label="'Traços, sons, cores e formas'"
                :val="form.indicacampoexperiencia3 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia4"
                :label="'Escuta, fala, pensamento e imaginação'"
                :val="form.indicacampoexperiencia4 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia5"
                :label="'Espaços, tempos, quantidade, relações e transformações'"
                :val="form.indicacampoexperiencia5 ? 'S' : 'N'"
              />
            </div>
          </Validator>
          <div style="display: flex; justify-content: flex-end; gap: 5px">
            <Input
              v-if="!this.id"
              class="input-qtdmodulosaula"
              type="number"
              label="Quantos módulos/aula?"
              v-model="form.qtdModulosAula"
              :v="$v.form.qtdModulosAula"
              :min="1"
              :max="quantidadeMaxAulasPermitidas"
            />
            <v-btn
              class="rounded-sm font-weight-regular"
              tile
              type="submit"
              :loading="loading"
              color="teal"
              dark
              style="height: 51px; margin-top: 8px"
              >Salvar</v-btn
            >
          </div>
          <div style="display: flex; justify-content: flex-end">
            <v-btn
              color="cyan"
              style="color: white"
              class="button-copiar-ultima-aula rounded-sm font-weight-regular"
              v-if="!id"
              :disabled="disabilitarBotaoCopiar"
              :loading="loadingCopiarAula"
              @click="getUltimaAula"
              >Copiar Última Aula</v-btn
            >
          </div>
        </form>
      </div>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="4000"
      height="10px"
      rounded="0"
    >
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import store from "@/store/index";
import {
  required,
  maxLength,
  integer,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";
import { alphaNumSpace, before } from "@/validations";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import parametros from "@/utils/parametros.js";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");
const PeriodoAvaliativoRepository = RepositoryFactory.get("periodoAvaliativo");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const setFormInicial = (props) => ({
  aaletivo: props.ano,
  ...dadosUser(),
  cdturma: props.cdturma,
  cdinstruc: props.cdinstruc,
  cddiscipl: props.disciplina,
  cdpravadi: "",
  dataaula: "",
  descricaoassuntolecionado: "",
  //identificadorplanejamento: '',
  descricaodesenvolvimentoaula: "",
  descricaorecursosutilizados: "",
  descricaoatividadeassociada: "",
  indicareposicao: "N",
  datareposicao: "",
  descricaoobservacao: "",
  indicasituacao: "E",
  descricaoobjetivo: "",
  tipoDeEnsino: props.tipoDeEnsino,
  indicacampoexperiencia1: "N",
  indicacampoexperiencia2: "N",
  indicacampoexperiencia3: "N",
  indicacampoexperiencia4: "N",
  indicacampoexperiencia5: "N",
  indicapresencial: "S",
  qtdModulosAula: 1,
});

function retornaIndicaPresencialInicial(indicamodelodeaula) {
  if (indicamodelodeaula === "P") return "S";
  else if (indicamodelodeaula === "R") return "N";
  else return "S";
}

export default {
  name: "AulaCadastro",
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    id: [Number, String],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    pagina: [Number],
    filtro: [Object],
    AEEouACP: [Boolean],
  },
  data() {
    return {
      form: setFormInicial(this.$props),
      msgArrayError: [],
      periodoAvaliativo: [],
      snackbar: false,
      submitText: "",
      loading: false,
      loadingCopiarAula: false,
      disabilitarBotaoCopiar: true,
      qtdModulosAula: 1,
      quantidadeMaxAulasPermitidas: 0,
      indicamodelodeaula: "",
      salvarAulaConsiderandoFrequencia: false,
      salvarAulaConsiderandoAusencia: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { cdtipesc, cdescola } = dadosUser();
      const periodo = await PeriodoAvaliativoRepository.getPeriodoTurmas({
        aaletivo: to.params.ano,
        cdtipesc,
        cdescola,
        cdturma: to.params.cdturma,
        cdinstruc: to.params.cdinstruc,
      });

      const tipoDeEnsino = to.params.tipoDeEnsino;
      const cdinstruc = to.params.cdinstruc;
      const aaletivo = to.params.ano;
      const quantidadeMaxAulasPermitidas =
        parametros.getQuantidadeMaxAulasPermitidas(tipoDeEnsino);
      const indicamodelodeaula =
        periodo.data.configuracaoAnoLetivo.indicamodelodeaula;
      let indicapresencial = "";

      let editar = {};
      if (to.params.id) {
        editar = await DiarioEscolarRepository.getAula(to.params.id);
        editar.data.results.cdinstruc = cdinstruc;
      }

      next((vm) => {
        vm.montarPeriodoAvaliativo(periodo.data.results);
        //
        if (to.params.id) {
          vm.load(editar.data.results);
        } else {
          indicapresencial = retornaIndicaPresencialInicial(indicamodelodeaula);
          vm.form.indicapresencial = indicapresencial;
        }
        vm.tipoDeEnsino = tipoDeEnsino;
        vm.cdinstruc = cdinstruc;
        vm.quantidadeMaxAulasPermitidas = quantidadeMaxAulasPermitidas;
        vm.indicamodelodeaula = indicamodelodeaula;
      });
    } catch (e) {
      next("/diario-escolar");
    }
  },
  created() {
    this.$Progress.finish();
  },
  watch: {
    "form.indicareposicao"(newVal, oldVal) {
      if (newVal === "N") {
        this.form.datareposicao = "";
      }
    },
  },
  validations() {
    return {
      form: {
        aaletivo: { required, integer, maxLength: maxLength(4) },
        cdtipesc: { required, integer },
        cdescola: { required, integer },
        cdpessoal: { required, integer },
        cdmatric: { required, integer },
        cdturma: { required, alphaNumSpace, maxLength: maxLength(4) },
        cddiscipl: { required, integer },
        cdpravadi: { required, alphaNumSpace },
        dataaula: {
          required,
          maxLength: maxLength(10),
          isValidDate: (value) => moment(value, "DD/MM/YYYY").isValid(),
        },
        descricaoassuntolecionado: { required, maxLength: maxLength(400) },
        //identificadorplanejamento: { },
        descricaodesenvolvimentoaula: { maxLength: maxLength(400) },
        descricaorecursosutilizados: { maxLength: maxLength(400) },
        descricaoatividadeassociada: { maxLength: maxLength(400) },
        descricaoobjetivo: { maxLength: maxLength(600) },
        indicareposicao: { required },
        datareposicao: {
          required: this.form.indicareposicao == "S" ? required : "",
          maxLength: maxLength(10),
          before: before(
            moment(this.form.dataaula, "DD/MM/YYYY").format("YYYY-MM-DD")
          ),
        },
        descricaoobservacao: { maxLength: maxLength(400) },
        indicasituacao: { required },
        indicacampoexperiencia1: { required },
        indicacampoexperiencia2: { required },
        indicacampoexperiencia3: { required },
        indicacampoexperiencia4: { required },
        indicacampoexperiencia5: { required },
        indicapresencial: { required },
        qtdModulosAula: {
          minValue: minValue(1),
          maxValue: maxValue(this.quantidadeMaxAulasPermitidas),
        },
        AEEouACP: this.AEEouACP,
      },
    };
  },

  methods: {
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
        return;
      }
      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = this.id ? "put" : "post";
        const { data } = await DiarioEscolarRepository[`${funcao}Aula`]({
          ...this.form,
          dataaula: moment(this.form.dataaula, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          datareposicao: this.form.datareposicao
            ? moment(this.form.datareposicao, "DD/MM/YYYY").format("YYYY-MM-DD")
            : "",
          AEEouACP: this.AEEouACP,
        });

        this.submitText = data.message;
        this.snackbar = true;
        const auxPeriodoAnterior = this.form.cdpravadi;
        this.form = setFormInicial(this.$props);
        this.form.cdpravadi = auxPeriodoAnterior;
        if (funcao === "post") {
          this.form.indicapresencial = retornaIndicaPresencialInicial(
            this.indicamodelodeaula
          );
        }
        this.$v.$reset();
        this.disabilitarBotaoCopiar = false;

        if (this.id) {
          this.$root.$router.push({
            name: "diario-escolar-aulas",
            params: {
              ano: this.ano,
              cdturma: this.cdturma,
              disciplina: this.disciplina,
              tipoDeEnsino: this.tipoDeEnsino,
              cdinstruc: this.cdinstruc,
              pagina: this.pagina,
              AEEouACP: this.AEEouACP,
            },
          });
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data.status == "ERROR_BUSINESS_RULE"
        ) {
          this.msgArrayError = error.response.data.errorMessage;
        }
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } finally {
        this.loading = false;
      }
    },
    montarPeriodoAvaliativo(data) {
      const formatedPeriodo = data.map((key) => ({
        value: key.cdpravadi,
        text: key.dspravadi,
      }));

      this.periodoAvaliativo = formatedPeriodo;
      if (data.length > 0) {
        this.form.cdpravadi = data[0].cdpravadi;
        for (let valor of data) {
          if (valor.aberto) {
            this.form.cdpravadi = valor.cdpravadi;
            break;
          }
        }
      }
    },
    load(data) {
      this.form = { ...data };
      this.form.dataaula = moment(data.dataaula, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
      this.form.datareposicao = moment(data.datareposicao, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
    },
    async getUltimaAula() {
      this.loadingCopiarAula = true;
      try {
        const { data } = await DiarioEscolarRepository.getAulasProfessor({
          ...dadosUser(),
          ultima: true,
          aaletivo: this.ano,
          cdturma: this.cdturma,
          cddiscipl: this.disciplina,
          tipoDeEnsino: this.tipoDeEnsino,
          cdinstruc: this.cdinstruc,
          AEEouACP: this.AEEouACP,
        });
        if (data.results.aulas.data.length > 0) {
          this.disabilitarBotaoCopiar = true;
          this.form = {
            ...data.results.aulas.data[0],
            identificadoraula: null,
            qtdModulosAula: 1,
            dataaula: moment(
              data.results.aulas.data[0].dataaula,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY"),
            datareposicao: data.results.aulas.data[0].datareposicao
              ? moment(
                  data.results.aulas.data[0].datareposicao,
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY")
              : "",
          };
        }
      } catch (error) {
        /* throw error; */
      } finally {
        this.loadingCopiarAula = false;
      }
    },
  },
};
</script>

<style>
.input-qtdmodulosaula {
  width: 20%;
}

@media only screen and (max-width: 500px) {
  .input-qtdmodulosaula {
    width: 100%;
  }
}

.button-copiar-ultima-aula {
  width: 405px;
}

@media only screen and (max-width: 500px) {
  .button-copiar-ultima-aula {
    width: 100%;
  }
}
</style>
